<template>
  <div v-if="isLoading" class="loader-backdrop">
    <div class="spinner"></div>
  </div>
  <section class="material-half-bg">
    <div class="cover"></div>
  </section>
  <section class="container mt-4">
    <h2 class="text-center">
      ใบรายงานการตรวจเช็คเครื่องมือแพทย์
      <b class="text-danger">เครื่องกระตุกหัวใจด้วยไฟฟ้า (Defibrillator)</b>
      <h3 class="mb-4">[{{ defibrillatorCode }}]</h3>
    </h2>

    <!-- Button -->
    <div class="text-center my-3">
      <button class="btn btn-success btn-lg" @click="openFormModal">
        เพิ่มรายการตรวจเช็ค
      </button>
    </div>

    <!-- ✅ Modal สำหรับเพิ่มรายการตรวจเช็ค -->
    <div
      class="modal fade"
      id="formInsertModal"
      tabindex="-1"
      aria-labelledby="formInsertModalLabel"
      aria-hidden="true"
      ref="formInsertModal"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="formInsertModalLabel">
              เพิ่มรายการตรวจเช็ค
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- 🟡 ย้ายฟอร์มเดิมที่มี class="form-insert" มาวางตรงนี้ -->
            <!-- Table -->
            <div class="form-insert">
              <table class="table table-bordered table-striped">
                <thead class="table-dark text-center">
                  <tr>
                    <th>ลำดับ</th>
                    <th>รายการตรวจสอบ</th>
                    <th>ผลการตรวจ</th>
                    <th>หมายเหตุ</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(item, index) in itemsWithIndex"
                    :key="index"
                  >
                    <tr v-if="item.category" class="table-secondary">
                      <td colspan="4">
                        <strong>{{ item.label }}</strong>
                      </td>
                    </tr>
                    <tr v-else>
                      <td>{{ item.displayIndex }}</td>
                      <td>{{ item.label }}</td>
                      <td>
                        <select class="form-select" v-model="item.result">
                          <option value="">-</option>
                          <option value="Y">✓ ผ่าน</option>
                          <option value="N">✗ ไม่ผ่าน</option>
                        </select>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          v-model="item.note"
                          placeholder="หมายเหตุ"
                        />
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>

              <div class="mb-3">
                <label class="form-label">วันที่บันทึก (Record Date)</label>
                <!-- <DatePicker v-model="form.record_date" :disabled="true"/> -->
                <DatePicker v-model="form.record_date" />
              </div>

              <div class="mb-3">
                <label class="form-label">หน่วยงาน (Department)</label>
                <v-select
                  v-model="form.group_id"
                  :options="groups"
                  label="name"
                  :reduce="(dept) => dept.id"
                  placeholder="- เลือกหน่วยงาน -"
                  :clearable="false"
                ></v-select>
              </div>

              <div class="mb-3">
                <label class="form-label">กะงาน (Shift Type)</label>
                <select
                  v-model="form.shift_type_id"
                  class="form-select"
                  required
                >
                  <option disabled value="">- เลือกกะงาน -</option>
                  <option
                    v-for="shift in shiftTypes"
                    :key="shift.id"
                    :value="shift.id"
                  >
                    {{ shift.name }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label class="form-label">ชื่อผู้บันทึก (Recorder)</label>
                <v-select
                  :dropdown-should-open="dropdownShouldOpen"
                  v-model="form.recorder_name"
                  :options="doctors"
                  label="name"
                  :reduce="(item) => item.name"
                  :clearable="false"
                  placeholder="ค้นหา..ชื่อผู้บันทึก"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      :required="!form.recorder_name"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              ปิด
            </button>
            <button class="btn btn-primary" @click="submitChecklist">
              บันทึกผลการตรวจสอบ
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5">
      <h4 class="text-center mb-4">ตารางแสดงผลการตรวจสอบ Defibrillator</h4>

      <form class="d-md-inline-block form-inline ms-auto me-0 me-md-3 mb-3">
        <div class="input-group">
          <select v-model="selectedMonth" class="form-select" required>
            <option value="" disabled>- เลือกเดือน -</option>
            <option
              v-for="month in months"
              :key="month.value"
              :value="month.value"
            >
              {{ month.name }}
            </option>
          </select>

          <select v-model="selectedYear" class="form-select ms-2" required>
            <option value="" disabled>- เลือกปี -</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year + 543 }}
            </option>
          </select>

          <button
            @click.prevent="clearFilters"
            class="btn btn-secondary"
            type="button"
          >
            <i class="bi bi-arrow-clockwise"></i> รีเซ็ต
          </button>
        </div>
      </form>

      <!-- Modal -->
      <div
        class="modal fade"
        id="recordDetailModal"
        tabindex="-1"
        aria-labelledby="recordDetailModalLabel"
        aria-hidden="true"
        ref="recordModal"
      >
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="recordDetailModalLabel">
                รายละเอียดการตรวจ (Checklist Details)
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              ></button>
            </div>
            <div class="modal-body" v-if="selectedRecord">
              <p><strong>วันที่:</strong> {{ selectedRecord.record_date }}</p>
              <p>
                <strong>เวลาที่บันทึก:</strong> {{ selectedRecord.record_time }}
              </p>
              <p>
                <strong>ผู้บันทึก:</strong> {{ selectedRecord.recorder_name }}
              </p>
              <p><strong>หน่วยงาน:</strong> {{ selectedRecord.group?.name }}</p>

              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="table-secondary">
                    <tr>
                      <th>รายการตรวจ</th>
                      <th>ผลการตรวจ</th>
                      <th>หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <template v-for="(item, i) in selectedRecord.items" :key="i + '-detail-row'">
                      <tr v-if="item.label?.category" class="table-secondary">
                        <td colspan="3">
                          <strong>{{ item.label?.label }}</strong>
                        </td>
                      </tr>
                      <tr v-else>
                        <td>{{ item.label?.label || 'ไม่ระบุ' }}</td>
                        <td>{{ item.result || '-' }}</td>
                        <td>{{ item.note || '-' }}</td>
                      </tr>
                    </template> -->
                    <tr v-for="(item, i) in selectedRecord.items" :key="i">
                      <td>{{ item.label?.label || "ไม่ระบุ" }}</td>
                      <td>{{ item.result || "-" }}</td>
                      <td>{{ item.note || "-" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                @click="closeModal"
              >
                ปิด
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table
          class="table table-bordered table-striped text-center align-middle"
        >
          <thead class="table-dark">
            <tr>
              <th>วันเวลาที่บันทึก</th>
              <th>ชื่อผู้บันทึก</th>
              <th>ชื่อหน่วยงาน</th>
            </tr>
          </thead>
          <tbody class="text-start">
            <tr
              v-for="(record, index) in records"
              :key="index"
              @click="selectRecord(record)"
            >
              <td>
                {{ formatDateTime(record.record_date, record.record_time) }}
              </td>
              <td>{{ record.recorder_name }}</td>
              <td>{{ record.group?.name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <hr />
    <h4 class="text-center">ตารางสรุปรายวันแบบปฏิทิน</h4>
    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead class="table-dark">
          <tr>
            <th>ช่วงเวลา</th>
            <th v-for="day in daysInMonth" :key="day">{{ day }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="shift in shiftLabels" :key="shift">
            <th>{{ shift }}</th>
            <td v-for="day in daysInMonth" :key="day">
              <div
                v-if="recordsByDayShift[shift] && recordsByDayShift[shift][day]"
              >
                ✅
                <!-- <div>{{ recordsByDayShift[shift][day].recorder }}</div> -->
              </div>
              <div v-else>-</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import axios from "axios";
import moment from "moment";
import "moment/locale/th";
import { Modal } from "bootstrap"; // Import bootstrap modal JS

moment.locale("th");

import DatePicker from "@/components/DatePicker.vue";

import axiosInstance from "@/utils/axiosInstance";
const now = moment();
const today = new Date();

const selectedMonth = ref(today.getMonth() + 1);
const selectedYear = ref(today.getFullYear());

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 3 }, (_, i) => currentYear - i);

const currentMonth = ref(moment().format("YYYY-MM")); // ex: "2025-10"
const daysInMonth = ref([]);

const itemsWithIndex = computed(() => {
  let counter = 1;
  return form.value.items.map((item) => {
    if (!item.category) {
      item.displayIndex = counter++;
    } else {
      item.displayIndex = null;
    }
    return item; // ❗ อย่าสร้าง object ใหม่
  });
});

const months = [
  { value: 1, name: "มกราคม" },
  { value: 2, name: "กุมภาพันธ์" },
  { value: 3, name: "มีนาคม" },
  { value: 4, name: "เมษายน" },
  { value: 5, name: "พฤษภาคม" },
  { value: 6, name: "มิถุนายน" },
  { value: 7, name: "กรกฎาคม" },
  { value: 8, name: "สิงหาคม" },
  { value: 9, name: "กันยายน" },
  { value: 10, name: "ตุลาคม" },
  { value: 11, name: "พฤศจิกายน" },
  { value: 12, name: "ธันวาคม" },
];

const shiftLabels = ref(["เช้า", "บ่าย", "ดึก"]);

const recordsByDayShift = ref({});

const formInsertModal = ref(null); // ✅ ref ไปยัง modal DOM
let formModalInstance = null;

function openFormModal() {
  if (!formModalInstance && formInsertModal.value) {
    formModalInstance = new Modal(formInsertModal.value);
  }
  formModalInstance?.show();
}

function generateDaysInMonth() {
  const days = [];
  const daysCount = moment(currentMonth.value, "YYYY-MM").daysInMonth();
  for (let i = 1; i <= daysCount; i++) {
    days.push(i);
  }
  daysInMonth.value = days;
}

function groupRecords() {
  const grouped = {};

  for (const shift of shiftLabels.value) {
    grouped[shift] = {};
  }

  calendarRecords.value.forEach((record) => {
    const day = parseInt(moment(record.date).format("D"), 10); // get day of month (1-31)
    const shift = record.shift; // must match shiftLabels
    grouped[shift][day] = record;
  });

  recordsByDayShift.value = grouped;
}

async function fetchCalendarData() {
  try {
    const response = await axiosInstance.get(
      "/defibrillator-checklist-calendar",
      {
        params: {
          month: currentMonth.value, // Format: "2025-10"
          defibrillator_id: defibrillatorId.value,
        },
      }
    );

    calendarRecords.value = response.data;
    groupRecords(); // Make sure this function exists
  } catch (error) {
    console.error("โหลดข้อมูลล้มเหลว", error);
  }
}

// สร้าง ref เพื่อเก็บ labels ที่ได้จาก API
const checklistTemplate = ref([]);

// ฟังก์ชัน fetch labels สำหรับ checklistTemplate
// โหลด template ไว้ก่อน
async function fetchChecklistTemplateLabels() {
  try {
    const response = await axiosInstance.get("/defibrillator-checklist-labels");
    if (Array.isArray(response.data)) {
      checklistTemplate.value = response.data;
    }
  } catch (error) {
    console.error("โหลด checklistTemplate ล้มเหลว:", error);
  }
}

// เมื่อ template เปลี่ยน → map ใส่ form.items แบบ reactive
watch(checklistTemplate, (newTemplate) => {
  if (newTemplate.length > 0) {
    form.value.items.splice(
      0,
      form.value.items.length,
      ...newTemplate.map((item) => ({
        label_id: item.id,
        label: item.label,
        category: item.category,
        result: "",
        note: "",
      }))
    );
  }
});

// ✅ ฟอร์มหลัก
const form = ref({
  defibrillator_id: "",
  group_id: "",
  shift_type_id: "",
  recorder_name: "",
  record_date: now.format("YYYY-MM-DD"),
  record_time: now.format("HH:mm:ss"),
  // items: checklistTemplate.map((item) => ({ ...item })), // clone
  // ตรวจสอบว่ามี label checklistTemplate หรือไม่ ถ้ามี map สร้าง items array
  items: checklistTemplate.value.map((item) => ({ ...item })),
});

const defibrillatorId = ref(null);
const defibrillatorCode = ref(null);

import { useRoute } from "vue-router";
import { computed } from "vue";

const route = useRoute();

const dropdownShouldOpen = (VueSelect) => {
  return VueSelect.search.length !== 0 && VueSelect.open;
};

// ฟังก์ชันดึงข้อมูล Defibrillator ตาม code (จาก params)
async function fetchDefibrillatorIdByCode() {
  try {
    const code = route.params.code;
    if (!code) return;
    const response = await axiosInstance.get(`/defibrillator/code/${code}`);
    if (response.data && response.data.id) {
      defibrillatorId.value = response.data.id;
      defibrillatorCode.value = response.data.code;
      form.value.defibrillator_id = response.data.id;
      form.value.group_id = response.data.group_id;
    }
    fetchCalendarData();
    fetchRecords();
  } catch (error) {
    showErrorAlert("เกิดข้อผิดพลาดในการค้นหา ID ของ Defibrillator");
  }
}

async function submitChecklist() {
  if (
    !form.value.group_id ||
    !form.value.shift_type_id ||
    !form.value.recorder_name
  ) {
    return showErrorAlert("กรุณากรอกข้อมูลให้ครบถ้วนก่อนส่ง");
  }

  // const incomplete = checklist.value.some(
  //   (item) => !item.category && !item.result
  // );

  // if (incomplete) {
  //   return showErrorAlert("กรุณาเลือกผลการตรวจสอบให้ครบทุกข้อ");
  // }

  // ตรวจสอบว่าเลือกผลการตรวจสอบให้ครบทุกข้อ (ยกเว้นหัวข้อ category)
  // const incomplete = form.value.items.some(
  //   (item) => !item.category && !item.result
  // );
  // if (incomplete) {
  //   return showErrorAlert("กรุณาเลือกผลการตรวจสอบให้ครบทุกข้อ");
  // }

  try {
    // const payload = {
    //   ...form.value,
    //   defibrillator_id: defibrillatorId.value,
    //   items: checklist.value,
    // };

    const response = await axiosInstance.post(
      "/defibrillator-checklist",
      form.value
    );

    alert("✅ ส่งผลการตรวจสอบเรียบร้อยแล้ว!");
    console.log(response.data);
    formModalInstance?.hide();

    // เคลียร์ข้อมูลในฟอร์มหลังจากส่งเสร็จ
    form.value.shift_type_id = "";
    form.value.recorder_name = "";
    form.value.note = "";

    fetchDefibrillatorIdByCode();
    // ถ้ามีฟิลด์อื่นที่ต้องการ reset ก็เพิ่มได้ เช่น checklist หรืออื่นๆ
    // ✅ เคลียร์ฟอร์มหรือรีเฟรช
    // checklist.value.forEach((item) => {
    //   if (!item.category) {
    //     item.result = "";
    //     item.note = "";
    //   }
    // });
  } catch (error) {
    console.error("❌ Submission failed:", error);
    showErrorAlert("เกิดข้อผิดพลาดในการส่งข้อมูล");
  }
}

// ✅ Checklist ref
// const checklist = ref([
//   { category: true, label: "ตรวจสอบสภาพทั่วไป" },
//   { label: "โครงสร้างเครื่อง / หน้าปัดและจอแสดงผล", result: "", note: "" },
//   { label: "สวิตช์ เปิด-ปิด / โหมดการใช้งาน", result: "", note: "" },
//   { label: "ปลั๊กไฟ / สายไฟ / สายดิน (GND)", result: "", note: "" },
//   { label: "EKG Electrode / Patient Cable", result: "", note: "" },
//   { label: "Paddle Electrode", result: "", note: "" },
//   { category: true, label: "เปิดเครื่องทดสอบประสิทธิภาพ" },
//   {
//     label: "ทดสอบแบตเตอรี่ (ถอดปลั๊ก) อย่างน้อย 30 นาที",
//     result: "",
//     note: "",
//   },
//   { label: "Self-test ของเครื่อง", result: "", note: "" },
//   { label: "หน้าจอแสดงผล", result: "", note: "" },
//   { label: "การทำงานของปุ่มปรับต่างๆ", result: "", note: "" },
//   { label: "Discharge พลังงานตามมาตรฐาน 3 ครั้ง", result: "", note: "" },
//   { label: "ทดสอบการทำงานของเครื่องพิมพ์ (Printer)", result: "", note: "" },
//   { category: true, label: "การจัดเตรียมอุปกรณ์ ความพร้อมใช้" },
//   { label: "กระดาษบันทึก / ครีมทาอิเล็กโตรด", result: "", note: "" },
//   { label: "External Pacemaker Paddle", result: "", note: "" },
//   { label: "ชาร์จแบตเตอรี่เตรียมพร้อม (4-8 ชั่วโมง)", result: "", note: "" },
//   { label: "กำหนดการสอบเทียบเครื่องมือแพทย์ (IPM Due)", result: "", note: "" },
// ]);

const doctors = ref([]);

async function getDoctors() {
  try {
    const res = await axios.get(
      "https://api-hos.wanorn.com/backend/api/doctor"
    );
    doctors.value = res.data.filter((doctor) => doctor.active !== "N");
  } catch (error) {
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  }
}

const groups = ref([]);
const shiftTypes = ref([]);

const fetchDropdownData = async () => {
  try {
    const [deptRes, shiftRes] = await Promise.all([
      axiosInstance.get("/group"),
      axiosInstance.get("/shift_type"),
    ]);
    groups.value = deptRes.data;
    shiftTypes.value = shiftRes.data;
  } catch (error) {
    showErrorAlert("Failed to load dropdown data");
  }
};

// ตารางข้อมูลทั้งหมด
const records = ref([]);
const selectedRecord = ref(null);
let modalInstance = null;
const recordModal = ref(null);
const calendarRecords = ref([]);

const selectRecord = async (record) => {
  try {
    // Assuming your API has a route like /api/defibrillator-checklist/{id}
    const response = await axiosInstance.get(
      `/defibrillator-checklist/${record.id}`
    );
    selectedRecord.value = response.data;

    // Show Bootstrap modal programmatically
    if (!modalInstance) {
      modalInstance = new Modal(recordModal.value);
    }
    modalInstance.show();
  } catch (error) {
    console.error("Failed to fetch checklist details", error);
  }
};

// โหลดข้อมูลจาก backend
const fetchRecords = async () => {
  try {
    const res = await axiosInstance.get(
      `/defibrillator-checklist?defibrillator_id=${defibrillatorId.value}`
    );
    records.value = res.data;
  } catch (err) {
    console.error("เกิดข้อผิดพลาดในการโหลดข้อมูล", err);
  }
};

// แสดงวันเวลา
const formatDateTime = (date, time) => {
  return moment(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss").format(
    "D MMM YY | HH:mm:ss"
  );
};

watch([selectedMonth, selectedYear], ([month, year]) => {
  if (month && year) {
    currentMonth.value = `${year}-${String(month).padStart(2, "0")}`;
    generateDaysInMonth();
    fetchCalendarData();
  }
});

watch([selectedMonth, selectedYear], async ([month, year]) => {
  if (month && year) {
    await fetchRecordsByMonthYear(month, year);
  }
});

async function fetchRecordsByMonthYear(month, year) {
  try {
    const res = await axiosInstance.get("/defibrillator-checklist", {
      params: {
        month,
        year,
        defibrillator_id: defibrillatorId.value,
      },
    });
    records.value = res.data;
  } catch (err) {
    console.error("โหลดข้อมูลรายเดือนล้มเหลว", err);
  }
}

const isLoading = ref(true);

// 🔁 Load data on mounted
// onMounted(() => {
//   fetchDropdownData();
//   getDoctors();
//   generateDaysInMonth();
//   // fetchCalendarData();
//   fetchDefibrillatorIdByCode();
//   // โหลด labels ทันทีเมื่อเรียกใช้ไฟล์นี้
//   fetchChecklistTemplateLabels();
// });
onMounted(async () => {
  isLoading.value = true; // เริ่มโหลด

  try {
    await Promise.all([
      fetchDropdownData(),
      getDoctors(),
      fetchDefibrillatorIdByCode(), // ← ในนี้มี fetchCalendarData ด้วย
      fetchChecklistTemplateLabels(),
    ]);

    generateDaysInMonth(); // ไม่ใช่ async, เรียกหลังโหลดก็พอ
  } catch (error) {
    console.error("มีข้อผิดพลาดระหว่างโหลดข้อมูล:", error);
    showErrorAlert("โหลดข้อมูลล้มเหลว");
  } finally {
    isLoading.value = false; // ✅ ซ่อน Loader เมื่อทุกอย่างเสร็จ
  }
});

// ✅ Optional: คุณอาจต้อง import หรือ define `showErrorAlert` ถ้าใช้
function showErrorAlert(msg) {
  alert(msg);
}

function clearFilters() {
  selectedMonth.value = today.getMonth() + 1;
  selectedYear.value = today.getFullYear();
}
</script>

<style scoped>
.loader-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 8px solid #ccc;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Spinner animation */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.cover {
  background: url("https://www.medicalintertec.com/wp-content/uploads/2023/03/efficia-dfm100-defibrillator.png")
    no-repeat center center;
  background-size: cover;
  height: 100%;
  opacity: 0.3;
  /* Adjust opacity value as needed */
}
</style>
